import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ACTIONS_TYPES } from 'redux/helper';
import Shared from 'screens/shared';
import { _t, locations, uniqueArray } from 'utils';

export default () => {
  const { [ACTIONS_TYPES.DATA_CENTER.GET_ALL]: dataCenters = [] } = useSelector((e) => e);
  const [filters, setFilters] = useState({
    location: '',
    searchText: '',
  });

  const dcLocations = uniqueArray(dataCenters.map((e) => e.properties.location));

  const applyFilters = () => {
    let filteredDataCenters = dataCenters;
    if (filters.location && filters.location !== 'all') {
      filteredDataCenters = filteredDataCenters
        .filter((dataCenter) => dataCenter.properties.location === filters.location);
    }

    if (filters.searchText) {
      filteredDataCenters = filteredDataCenters
        .filter((dataCenter) => (
          dataCenter.properties.name.toLowerCase()
            .indexOf(filters.searchText.toLowerCase()) !== -1));
    }

    return filteredDataCenters;
  };

  const setFilterValue = (value) => setFilters((e) => ({ ...e, ...value }));

  // let locationsToFilter = Array.from(
  //   dataCenters
  //     .reduce((t, dataCenter) => t.add(dataCenter.properties.location), new Set()),
  // ) || [];

  // locationsToFilter =
  // [['all', _t('Show All')], ...locationsToFilter.map((e) => ([e, locations[e].name]))];

  const filterFields = [
    {
      name: 'location',
      options: [],
      type: 'dropdown',
      title: _t('Select Location'),
      onChange: (location) => setFilterValue({ location }),
    },
    {
      name: 'search',
      type: 'text',
      title: _t('Search'),
      onChange: (searchText) => setFilterValue({ searchText }),
    },
  ];

  const changeFields = [{
    name: 'location',
    props: {
      options: [['all', _t('Show All Data Centers')], ...dcLocations.map((key) => ([key, (
        <div className="locations-dropdown">
          <img src={locations[key].image} alt={key} />
          <div>
            <span>{locations[key].name}</span>
            <br />
            <span style={{ marginTop: -5, display: 'block', fontSize: 10 }}>{key}</span>
          </div>
        </div>
      )]))],
    },
  }];

  return ([
    applyFilters(),
    <Shared.forms.Form
      fields={filterFields}
      fieldsValues={filters}
      isActionButtons={false}
      changeFields={changeFields}
    />,
  ]);
};
